const scheduledServicesCalendarCalendar = {
  allDay: 'All day',
  today: 'Today',
  month: 'Month',
  week: 'Week',
  day: 'Day',
  agenda: 'Agenda',
  date: 'Date',
  time: 'Time',
  event: 'Event',
  showMore: '+ Events ',
};

export default scheduledServicesCalendarCalendar;
